import { call, put, takeLatest, select } from 'redux-saga/effects';
import querystring from 'qs';
import { singleItemActions as actions } from '.';
import { SingleItemPayload } from './types';
import {
  selectErpSystem,
  selectLanguage,
} from 'app/features/erpSystem/slice/selectors';
import { SingleItemResponse } from 'app/features/items/slice/types';
import { transformDTO } from './utils';
import { notificationsActions } from 'app/features/notifications/slice';

export function* fetchSingleItem(action) {
  const { payload }: { payload: SingleItemPayload } = action;
  const { getSingleItemSuccess, getSingleItemFail } = actions;
  const erpSystem = yield select(selectErpSystem);
  const language = yield select(selectLanguage);

  try {
    const singleItemResponse = yield call(
      fetch,
      `/gasket-configurator/api/items?${querystring.stringify(
        { erpSystem, lang: language, ...payload },
        { arrayFormat: 'comma' },
      )}`,
    );

    if (singleItemResponse.status !== 200) {
      return yield put(getSingleItemFail('failed to fetch'));
    } else {
      const { items }: { items: SingleItemResponse[] } =
        yield singleItemResponse.json();

      if (items.length === 0) {
        yield put(
          notificationsActions.setNotification({
            timeoutId: Date.now().toString(),
            status: 'info',
            notificationKey: 'infoSingleItemNotExist',
            isDismissed: false,
          }),
        );
        return yield put(getSingleItemFail('No item fetched'));
      }

      const singleItem = transformDTO(items[0]);

      return yield put(getSingleItemSuccess(singleItem));
    }
  } catch (e) {
    yield put(getSingleItemFail(e));
  }
}
export function* singleItemSaga() {
  yield takeLatest(actions.getSingleItem.type, fetchSingleItem);
}
